export enum MuteState {
  Unmuted = '0',
  Muted = '1'
}
